module.exports = __webpack_public_path__ + "static/media/6@3x.e92d8d9e.png";